export const A_COMMON_GET_TOKEN = 'A_COMMON_GET_TOKEN';
export const A_COMMON_CLEAR_TOKEN = 'A_COMMON_CLEAR_TOKEN';

export const M_COMMON_SET_TOKEN = 'M_COMMON_SET_TOKEN';
